import { render, staticRenderFns } from "./BatchProduction.vue?vue&type=template&id=70ee6e9c&scoped=true"
import script from "./BatchProduction.vue?vue&type=script&lang=js"
export * from "./BatchProduction.vue?vue&type=script&lang=js"
import style0 from "./BatchProduction.vue?vue&type=style&index=0&id=70ee6e9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ee6e9c",
  null
  
)

export default component.exports